import Table from '../../table.js';

namespace('IO.Views.Properties', function (exports) {
  'use strict';

  var Index = Table.extend({
    dom: {
      DATATABLES: 'table.display',
    },

    opts: {
      ajaxSource: 'properties.json',
      controller: 'properties',
      filter: true,
      title: 'Click to edit',
      aoColumnDefs: [
        {
          aTargets: [0],
        },
      ],
    },
  });

  exports.Index = Index;
});
